import React from 'react'
import './styles.scss'
import { config } from './config'
import { Sparkline } from 'components/sparkline'
import { ScaleThreshold, scaleThreshold } from 'd3-scale'

const getDiff = (v1: number, v2: number) => {
  let d = +((v2 * 100) / v1 - 100).toFixed(0)
  // if (d > 0) d = '+' + d
  // if (d < 0) d = '–' + Math.abs(d)
  return d
}
const f = new Intl.NumberFormat('de-CH')
const formatNumber = num => {
  return num > 9999 ? f.format(num) : num
}
const formatChange = (num: number) => {
  let str = num < 0 ? '–' + Math.abs(num) : num > 0 ? '+' + num : 0
  return str
}

const colors = [
  '#378EBD',
  '#9BC6DE',
  '#CDE2EE',
  '#f4cccf',
  '#e9999f',
  '#d3343f'
]

const colors2 = ['#479260', '#A3C8AF', '#D1AACF', '#A757A3'].reverse()

let color = scaleThreshold<number, string>()
  .domain([-100, -50, 0, 50, 100])
  .range(colors)
let color2 = scaleThreshold<number, string>()
  .domain([25, 50, 75])
  .range(colors2)

interface Props {
  data: {
    c: number
    de: string
    measures: number | '–'
    data: {}[]
    sums: { s: number; a: number; t: string; f: string }[]
    difs: number[]
  }[]
}
const arrAve = arr => {
  return arr.reduce((a, b) => a + +b, 0) / arr.length
}
export const SevenDaySumTable = ({ data }: Props) => (
  <>
    <div className='ui text container colorkeys'>
      {' '}
      <ColorKey
        range={colors}
        domain={['-100', '-50', '0', '+50', '+100']}
        title='Veränderung in %'
        sub='der Neuinfektionen von Woche zu Woche'
      />
      <ColorKey
        range={colors2}
        domain={[25, 50, 75]}
        title='Strenge der Massnahmen'
        sub='100 = am striktesten'
      />
    </div>
    <div className='tableWrapper'>
      <div className='keyImageRow'>
        {!config.isMobile && <div className='cases' />}
        <div className='sevenday'>
          <img src={require('images/arr-03.svg')} width='100px' />
        </div>
        <div className='dif'>
          <img src={require('images/arr-01.svg')} width='100%' />
        </div>
        <div className='dif'>
          <img src={require('images/arr-01.svg')} width='100%' />
        </div>
        <div className='dif'>
          <img src={require('images/arr-02.svg')} width='100%' />
        </div>{' '}
        <div className='measures'></div>
      </div>

      <div className='keyRow'>
        {!config.isMobile && <div className='cases'>Gesamtzahl der Fälle</div>}
        <div className='sevenday'>
          <div>
            Summe der Neuinfektionen über <span>7 Tage</span>
          </div>
        </div>
        <div className='dif'>
          <div>zur Woche davor</div>
        </div>
        <div className='dif'>
          <div>zur Woche davor</div>
        </div>
        <div className='dif'>
          <div>zur Woche davor</div>
        </div>{' '}
        <div className='measures'>Mass-nahmen</div>
      </div>
      {data
        .filter(f => f.c > 2000)

        .sort((a, b) => {
          // return arrAve(b.difs) - arrAve(a.difs)
          return b.difs[0] - a.difs[0]
        })
        .map(c => {
          if (!c.sums || c.sums.length == 0) return
          let sum = c.sums.map(a => a.s)
          return (
            <div className={'row ' + c.code}>
              <div className='name'>{c.de}</div>

              {!config.isMobile && (
                <>
                  <div className='cases'>{formatNumber(c.c)}</div>
                  <div className='spark'>
                    <Sparkline values={sum} />
                  </div>
                </>
              )}
              <div className='sum'>
                {formatNumber(c.sums[c.sums.length - 1].s)}
              </div>
              {c.difs.map(d => {
                return (
                  <div
                    className='dif'
                    style={{
                      backgroundColor: color(d),
                      color: Math.abs(d) >= 100 ? '#fff' : '#202346'
                    }}
                  >
                    {formatChange(d)}%
                  </div>
                )
              })}

              <div
                className='measures'
                style={{
                  backgroundColor:
                    c.measures !== '–' ? color2(c.measures) : '#ddd',
                  color: c.measures < 25 || c.measures > 75 ? '#fff' : '#202346'
                }}
              >
                {c.measures}
              </div>
            </div>
          )
        })}
    </div>
    <div className='footnote'>
      Alle Länder mit mindestens 2000 Fällen. Ohne Kasachstan und Äquatorial
      Guinea.
    </div>
    {/* <table className='secWaveTable'>
      <thead>
        <tr className='fr'>
          {!config.isMobile && (
            <>
              <td className='name'></td>
              <td></td>
              <td></td>
            </>
          )}
          <td className='sum7day'>
            <img src={require('images/arr-03.svg')} width='100%' />
          </td>
          <td className='sum7day'>
            <img src={require('images/arr-01.svg')} width='100%' />
          </td>{' '}
          <td className='sum7day'>
            <img src={require('images/arr-01.svg')} width='100%' />
          </td>{' '}
          <td className='sum7day'>
            <img src={require('images/arr-02.svg')} width='100%' />
          </td>
        </tr>
      <tr>
          {!config.isMobile && (
            <>
              <td className='name' />
              <td className='cases'>Total der Fälle</td>
            </>
          )}
          <td colSpan={config.isMobile ? 2 : 2} className='sum7day'>
            Summe der Neuinfektionen über 7 Tage
          </td>
          <td className='dif'>zur Woche davor</td>
          <td className='dif'>zur Woche davor</td>
          <td className='dif'>zur Woche davor</td>
          <td className='measures'>Strenge der Massnahmen</td>
        </tr>
      </thead>
      <tbody>

        {data &&
          data
            .filter(f => f.c > 2000)

            .sort((a, b) => {
              // return arrAve(b.difs) - arrAve(a.difs)
              return b.difs[0] - a.difs[0]
            })
            .map(c => {
              if (!c.sums || c.sums.length == 0) return
              let sum = c.sums.map(a => a.s)
              let difs = c.difs
              return (
                <tr className={c.code}>
                  <td className='name'>
                    <i className={c.code.toLowerCase() + ' flag'} /> 
                    {c.de}
                  </td>
                  {!config.isMobile && (
                    <>
                      <td className='cases'>{formatNumber(c.c)}</td>
                      <td className='spark'>
                        <Sparkline values={sum} />
                      </td>
                    </>
                  )}
                  <td className='sum7day'>
                    <div className='yBG'>
                      {formatNumber(c.sums[c.sums.length - 1].s)}
                    </div>
                  </td>
                  {difs.map((d, i) => {
                    return (
                      <td
                        className='dif'
                        style={{
                          backgroundColor: color(d),
                          color: Math.abs(d) >= 100 ? '#fff' : '#202346'
                        }}
                      >
                        {formatChange(d)}%
                      </td>
                    )
                  })}
                  <td className='measures'>
                    <div
                      style={{
                        backgroundColor:
                          c.measures !== '–' ? color2(c.measures) : '#ddd',
                        color:
                          c.measures < 25 || c.measures > 75
                            ? '#fff'
                            : '#202346'
                      }}
                    >
                      {c.measures}
                    </div>
                  </td>
                </tr>
              )
            })}
      </tbody>
    </table> */}
  </>
)

const ColorKey = ({
  range,
  domain,
  title,
  sub
}: {
  range: number[] | string[]
  domain: number[] | string[]
  title?: string
  sub?: string
}) => {
  return (
    <div className='colorKey'>
      {title && <div className='title'>{title}</div>}
      {sub && <div className='sub'>{sub}</div>}
      <div className='swatches'>
        {range.map(c => (
          <div style={{ backgroundColor: c }} className='swatch' />
        ))}
      </div>{' '}
      <div className='values'>
        {domain.map(c => (
          <div className='value'>{c}</div>
        ))}
      </div>
    </div>
  )
}
